import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { createErrorHandler } from '@sentry/angular';
import { UserService } from './user/user.service';

@Injectable({
  providedIn: 'root'
})
export class CustomErrorHandler implements ErrorHandler {
  static isSentryEnabled: boolean;

  sentryError = createErrorHandler({ showDialog: false });

  constructor(private userService: UserService) { }

  handleError(error: any) {
    const originalError = error?.rejection || error?.originalError || error;
    const errorMessage = originalError?.message || originalError || '';
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(errorMessage)) {
      try {
        window.location.reload();
      } catch (err) { }
      return;
    }

    // Skip errors with no meaningful message
    if (!errorMessage || errorMessage === 'undefined') {
      console.error(error);
      return;
    }

    if (CustomErrorHandler.isSentryEnabled) {
      const user = this.userService.userData;
      if (user?.id) {
        Sentry.setUser({ id: user.id });
      }

      this.sentryError.handleError(error);
    } else {
      console.error(error);
    }
  }
}
